import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import clone from 'lodash/clone';
import css from './index.scss';
import Badge from '../../components/badge/index';
import GroupInfo from '../../components/group-info/index';
import { truncateCharacters } from '../../helpers/utils';

class AssignItem extends Component {
    constructor(props) {
        super(props);
        const { child, isExpandable, info, disabled } = this.props;
        this.state = {
            style: this.setStyle(info, disabled),
            children: isExpandable ? child.data : [],
            showChildren: false
        };
    }

    setStyle = (info, disabled) => {
        if (disabled) {
            return `${css.disableListItem}`;
        } else if (info.selected) {
            return `${css.info} ${css.highlight}`;
        }

        return `${css.info}`;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.info.selected !== undefined) {
            const { info, disabled } = nextProps;
            this.setState({ style: this.setStyle(info, disabled) });
        }
    }

    onSelection = (element) => {
        const checked = element.target.checked;
        const { isExpandable } = this.props;
        if (checked) {
            this.setState({
                style: `${css.info} ${css.highlight}`,
                showChildren: isExpandable ? checked : false
            });
        } else {
            this.setState({
                style: `${css.info}`,
                showChildren: isExpandable ? checked : false
            });
        }

        this.props.handleOnItemSelection(element.target.id, checked);
    }

    onGroupSelection = (element) => {
        let classGroups = clone(this.state.children);
        const { id } = this.props;
        classGroups = classGroups.map((group) => {
            if (group.id === parseInt(element.target.id.split('_')[1], 10)) {
                group.isDefault = true;
                group.isAssigned = true;
            } else {
                group.isDefault = false;
                group.isAssigned = false;
            }

            return group;
        });

        this.setState({ children: classGroups });
        this.props.handleOnChildSelection(id, classGroups);
    }

    render() {
        let index = 0;
        let additionalInfo = null;
        const { info, child, isExpandable, name, id } = this.props;
        const groups = this.state.children.map((val) => {
            index += 1;
            val.classId = id;
            return (<GroupInfo
                group={val}
                isMultiSelect={child.isMultiSelect}
                key={`${id}_${val.id}_${index}`}
                onGroupSelection={this.onGroupSelection} />);
        });

        if (info.additionalInfo.length > 0) {
            additionalInfo = info.additionalInfo.map((val) => {
                val = truncateCharacters('teacher', val);
                return <div key={`${val}_${index}`}>{val}</div>;
            });
        }

        return (
            <div>
                <div className={this.state.style}>
                    <div className={css.checkbox}>
                        <input
                            checked={info.selected}
                            className={css.name}
                            id={this.props.elementId}
                            onChange={this.onSelection}
                            type="checkbox"
                        />
                        <label className={css.chklabel} htmlFor={this.props.elementId} />
                        <span className={css.className}>{name}</span>
                    </div>
                    <div className={css.yearGroupContainer}>
                        <Badge
                            badgeStyle={`${css.yearGroup} ${info.badgeStyle}`}
                            content={info.badgeContent} />
                    </div>
                    <div className={css.additionalInfo}>{additionalInfo}</div>
                </div>
                <div className={css.childContainer}>
                    {(isExpandable && this.state.showChildren
                        && child.data.length > 0) ? groups : null}
                </div>
            </div>
        );
    }
}

AssignItem.propTypes = {
    id: PropTypes.number,
    elementId: PropTypes.string,
    name: PropTypes.string,
    info: PropTypes.object,
    disabled: PropTypes.bool,
    isExpandable: PropTypes.bool,
    child: PropTypes.object,
    handleOnItemSelection: PropTypes.func,
    handleOnChildSelection: PropTypes.func
};

export default (styleable(css)(AssignItem));



// WEBPACK FOOTER //
// ./app/components/assign-item/index.js